import React ,{useEffect} from "react";
import { useParams, Link } from "react-router-dom";
import blogs from "../data/blogdata";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram,FaUser ,FaClock,FaShare,FaRegCalendarAlt} from 'react-icons/fa';
import { SiX } from 'react-icons/si';

export default function BlogDetailPage() {
  const { id } = useParams();
  const blog = blogs.find((b) => b.id === Number(id));

  const otherBlogs = blogs.filter((b) => b.id !== blog?.id); // ✅ Use this only

  useEffect(() => {
     console.log("Setting Title:", blog.title);
    if (blog?.title) {
      document.title = blog.title + " | Pravisht Blog";
    } else {
      document.title = "Blog not found | Pravisht";
    }
  }, [blog]);

  // 👇 Replace URL with title in tab (but keep data by id)
  useEffect(() => {
    if (blog?.title) {
      const titleSlug = blog.title.toLowerCase().replace(/\s+/g, "-");
      const desiredPath = `/blog/${titleSlug}`;
      if (window.location.pathname !== desiredPath) {
        window.history.replaceState(null, "", desiredPath);
      }
    }
  }, [blog]);

  if (!blog) {
    return <div className="container">Blog not found.</div>;
  }

  return (
    <div className="blogdetail-container">
      <div className="breadcrumb">
        <a href="/" className="mx-1">Home</a> &gt;
        {/* <a href="/Blog" className="mx-1">Blog List</a> &gt; */}
        <Link to="/Blog">Blog List</Link>&gt;
        <span className="mx-1">Blogs Detail</span>
      </div>


      <div className="main blogdetail-section">
        <h1 className="best-post-content-title">{blog.title}</h1>
         <div className="post__card_cat">{blog.category}</div>

        <div className="blog-header-row">
          <div className="blog-header-image">
            <img src={blog.image} alt={blog.title} className="best-post-image" />
          </div>
          <div className="blog-header-info">
  {/* Author */}
  <div className="info-block">
    <FaUser className="info-icon" />
    <div className="info-text">
      <p className="label">Written By :</p>
      <p className="value">{blog.author}</p>
    </div>
  </div>

  {/* Read Time */}
  <div className="info-block">
    <FaClock className="info-icon" />
    <div className="info-text">
      <p className="label">Read Time :</p>
      <p className="value">{blog.readTime}</p>
    </div>
  </div>

  {/* Publish Date */}
  <div className="info-block">
    <FaRegCalendarAlt className="info-icon" />
    <div className="info-text">
      <p className="label">Posted On :</p>
      <p className="value">{blog.date}</p>
    </div>
  </div>

  {/* Share */}
  <div className="info-block">
    {/* <FaShare className="info-icon" /> */}
    <div className="info-text">
      <p className="label" style={{color:'#000',fontSize:'24px'}}>Share Article :</p>
      <div className="button-group">
        <a href='https://www.facebook.com/share/o9V38G7km7WX4sqg/?mibextid=LQQJ4d'><FaFacebook /></a>
        <a href='https://x.com/Pravisht5'><SiX /></a>
        <a href='https://in.linkedin.com/company/pravishtdigital'><FaLinkedin /></a>
        <a href='https://www.instagram.com/pravisht_digital?igsh=MXFycGlmMHN2bno2ag=='><FaInstagram /></a>
      </div>
    </div>
  </div>
</div>
        </div>

        <div className="content">
          <p>{blog.content}</p>
        </div>
      </div>

    
      <div className="row other-blogs">
        <div>  <h3 className="best-post-content-cat">RELATED BLOG POST</h3>
        {otherBlogs.slice(0, 3).map((b) => (   // ✅ Use otherBlogs here, and limit to 3 if you like
          <div key={b.id} className="post__card-2">
            <div className="post__card_-2">
              <div className="post__card__image-2" style={{ backgroundImage: `url(${b.image})` }} />
              <div className="post__card_meta-2">
                 <div className="post__card_cat">{b.category}</div>
                <h4 className="post__card_title-2">{b.title}</h4>
                <p className="post__card_alttitle-2">{b.description}</p>
                {/* <Link to={`/blog/${b.id}`} className="readmore-btn">Read More</Link> */}
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                    <p className="post__card_alttitle-2"><span style={{color:"#000", fontWeight:"500"}}>Posted On : </span>{b.date}</p>
                    <Link to={`/blog/${b.id}`} className="readmore-btn">
                    Read More<span> →</span>
                    </Link>         
                </div>
              </div>
            </div>
          </div>
          
        ))}
        </div>
      </div>
    </div>
  );
}
